import React, { Component } from 'react'

export default function(ComposedComponent) {
  class Authentication extends Component {
    componentWillMount() {
      this.checkToken()

      if (!localStorage.ucn) {
        this.props.history.push('/login')
      }
    }

    componentWillUpdate(nextProps) {
      this.checkToken()

      if (!localStorage.ucn) {
        this.props.history.push('/login')
      }
    }

    checkToken() {
      if (
        !localStorage.token ||
        !localStorage.ucn ||
        localStorage.expirationTime < Date.now()
      ) {
        localStorage.clear()
      }
    }

    render() {
      return <ComposedComponent {...this.props} />
    }
  }

  return Authentication
}
